<template>
  <div>
    <table class="table table-sm color mb-2">
      <caption class="caption table-caption">Settings</caption>
      <tbody>
        <tr v-if="showYieldSettings || showSpreadSettings">
          <th class="text-left font-weight-normal">Price ($)</th>
          <td class="text-right">
            <b-form-input id="price" v-model="price" class="calculation-settings-input" @change='$emit("priceChange", price)'></b-form-input>
          </td>
        </tr>
        <tr v-if="showPriceSettings">
          <th class="text-left font-weight-normal">Yield (%)</th>
          <td class="text-right">
            <b-form-input id="yld" v-model="yld" class="calculation-settings-input" @change='$emit("yieldChange", yld)'></b-form-input>
          </td>
        </tr>
        <tr v-if="showPriceSettings">
          <th class="text-left font-weight-normal">Spread (bp)</th>
          <td class="text-right">
            <b-form-input id="spread" v-model="spread" class="calculation-settings-input" @change='$emit("spreadChange", spread)'></b-form-input>
          </td>
        </tr>
        <tr v-if="showPriceSettings || showSpreadSettings">
          <th class="text-left font-weight-normal">Benchmark Rate (%)</th>
          <td class="text-right">
            <b-form-input id="refCurve" v-model="refCurve" class="calculation-settings-input"  @change='$emit("refCurveChange", refCurve)'></b-form-input>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: {
    showPriceSettings: Boolean,
    showYieldSettings: Boolean,
    showSpreadSettings: Boolean,
    inputYield: {},
    inputSpread: {},
    inputPrice: {},
    inputRefCurve: {}
  },

  created() {
    this.yld = this.inputYield;
    this.spread = this.inputSpread;
    this.refCurve = this.inputRefCurve;
    this.price = this.inputPrice;
  },

  data() {
    return {
      yld: {},
      spread: {},
      price: {},
      refCurve: {}
    }
  }
}
</script>